const SCHOOL_NAME_BY_ID = {
  mma: 'Mountainside Music Academy',
  lsma: 'Lakeside Music Academy',
  tma: 'Treeside Music Academy',
  mor: 'Morningside Music Academy',
  psma: 'Parkside Music Academy',
  tem: 'Tempe Music Academy',
  den: 'Denton Music Academy',
  tul: 'Tulsa Music Academy',
};

export const toProperCase = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\b([a-z])/g, (match) => match.toUpperCase())
    .replace(/([-’'])([a-z])/g, (match, punctuation, character) =>
      `${punctuation}${character.toUpperCase()}`
    );

export const extractFirstName = (fullName) => {
  const normalizedName = toProperCase(fullName)
    .split(/\s+(?:and|&)\s+|,|\/|\+/i)[0]
    .trim();

  return normalizedName.split(/\s+/).filter(Boolean)[0] || '';
};

export const formatListForSentence = (items) => {
  const cleanedItems = items.filter(Boolean);

  if (cleanedItems.length === 0) return '';
  if (cleanedItems.length === 1) return cleanedItems[0];
  if (cleanedItems.length === 2) return `${cleanedItems[0]} and ${cleanedItems[1]}`;

  return `${cleanedItems.slice(0, -1).join(', ')}, and ${cleanedItems[cleanedItems.length - 1]}`;
};

const normalizeNameForComparison = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z\s]/g, ' ')
    .replace(/\s+/g, ' ');

const uniqueValues = (values) =>
  values.filter((value, index, list) => value && list.indexOf(value) === index);

const getInstrumentName = (instrument) =>
  toProperCase(typeof instrument === 'string' ? instrument : instrument?.name);

export const buildSmsTemplate = ({ familyInfo = {}, whichSchool = '' } = {}) => {
  const students = Array.isArray(familyInfo?.students) ? familyInfo.students : [];
  const parentFirstName = extractFirstName(familyInfo?.primaryParentName) || 'Parent';
  const schoolName = SCHOOL_NAME_BY_ID[String(whichSchool || '').trim().toLowerCase()] || 'School';
  const uniqueStudentNames = uniqueValues(
    students.map((student) => extractFirstName(student?.studentName))
  );
  const normalizedParentName = normalizeNameForComparison(familyInfo?.primaryParentName);
  const normalizedStudentName = normalizeNameForComparison(students[0]?.studentName);
  const normalizedParentFirstName = normalizeNameForComparison(parentFirstName);
  const normalizedStudentFirstName = normalizeNameForComparison(uniqueStudentNames[0]);
  const isSelfInquiry =
    students.length === 1 &&
    ((normalizedParentName && normalizedParentName === normalizedStudentName) ||
      (normalizedParentName &&
        normalizedStudentName &&
        (normalizedParentName.includes(normalizedStudentName) ||
          normalizedStudentName.includes(normalizedParentName))) ||
      (normalizedParentFirstName && normalizedParentFirstName === normalizedStudentFirstName));
  const studentNames = formatListForSentence(uniqueStudentNames) || 'Student';
  const instrumentNames =
    formatListForSentence(
      uniqueValues(
        students
          .flatMap((student) =>
            Array.isArray(student?.instrumentList) ? student.instrumentList : []
          )
          .map(getInstrumentName)
      )
    ) || '[instrument]';
  const studentText = isSelfInquiry ? '' : ` for ${studentNames}`;

  return `Hi ${parentFirstName}, this is Courtney from ${schoolName}.

I see you’re looking for in-home ${instrumentNames} lessons${studentText}. I’m talking with a few teachers now to match you with the best fit for your availability. I’ll get back to you with a couple options as soon as I can. Does texting this number work best for you?`;
};
